import { render, staticRenderFns } from "./about.vue?vue&type=template&id=ffeb1dfc&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"
import style0 from "./about.vue?vue&type=style&index=0&id=ffeb1dfc&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/about.less?vue&type=style&index=1&id=ffeb1dfc&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffeb1dfc",
  null
  
)

export default component.exports